import { useQuery } from 'react-query';
import { getAllResearchKpis } from 'apis/projectProposals.api';
import { useMemo } from 'react';

const useGetResearchKpis = (yearProposed, appliedYear, conds) => {
  const { data: researchKpisData, ...rest } = useQuery(
    ['projectProposalResearchKpis', yearProposed],
    () => getAllResearchKpis({ appliedYear }),
    {
      ...conds,
    }
  );

  const researchKpis = useMemo(() => researchKpisData?.data ?? [], [researchKpisData]);

  return {
    data: researchKpis,
    ...rest,
  };
};

export default useGetResearchKpis;
